module.exports = __webpack_public_path__ + "static/logo-cornell-67fef0ea3961a37c957c19d0b65848b1.svg";